"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _RangeFilter = _interopRequireDefault(require("../RangeFilter"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var config = function config(dataSource) {
  var programFilters = (0, _lodash.uniq)(dataSource.map(function (r) {
    return r.program;
  })).map(function (s) {
    return {
      text: s,
      value: s
    };
  });
  var columns = [{
    title: 'Period',
    dataIndex: 'period',
    key: 'period',
    filterDropdown: function filterDropdown(props) {
      return /*#__PURE__*/_react.default.createElement(_RangeFilter.default, props);
    },
    onFilter: (0, _utils.datePeriodFilter)('periodStart', 'periodEnd'),
    render: function render(id, record) {
      return record.status === _utils.SubscriptionStatuses.ACTIVE || !record.periodEnd ? "".concat(_momentTimezone.default.unix(record.periodStart).format('MM/DD/YYYY'), " -") : "".concat(_momentTimezone.default.unix(record.periodStart).format('MM/DD/YYYY'), " - ").concat(_momentTimezone.default.unix(record.periodEnd).format('MM/DD/YYYY'));
    },
    sorter: (0, _utils.timeSorter)('periodStart'),
    width: '25%'
  }, {
    title: 'Program',
    dataIndex: 'program',
    key: 'program',
    filters: programFilters,
    onFilter: (0, _utils.filter)('program'),
    sorter: (0, _utils.stringSorter)('program'),
    width: '15%'
  }, {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    render: function render(id, record) {
      return "USD ".concat(record.price);
    },
    sorter: (0, _utils.digitSorter)('price'),
    width: '15%'
  }, {
    title: 'Reason',
    dataIndex: 'reason',
    key: 'reason',
    render: function render(text, record) {
      return record.reason || '-';
    },
    width: '45%'
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    rowKey: 'id'
  };
};
var _default = config;
exports.default = _default;